import React, { useRef, useEffect } from 'react'
const { Input } = window.mdb

export default function Field({ name, type="text", label, value, helper, onChange, error = "", margin = true, required = true }) {
    const wrapperRef = useRef(null)

    useEffect(() => {
        let instance
        if (wrapperRef.current) {
            instance = new Input(wrapperRef.current)
        }
        return () => {
            if (instance) instance.dispose()
        }
    }, [])

    useEffect(() => {
        if (wrapperRef.current) {
            const existing = Input.getInstance(wrapperRef.current)
            if (existing) existing.update()
        }
    }, [value])

    return (
        <div ref={wrapperRef} className={"form-outline" + (margin ? " mb-4" : "")}>
            <input
                type={type}
                name={name}
                className={
                    "form-control" + (error ? " is-invalid" : "")
                }
                value={value}
                onChange={onChange}
                required={required}
            />
            <label className="form-label" htmlFor={name}>{label}</label>
        </div>
    )
}
